import React from 'react';

import ExportCharterDepartureManifestForm from '../Common/Forms/ExportCharterDepartureManifestForm';
import ExportFlightBookingsForm from '../Common/Forms/ExportFlightBookingsForm';

import ContentWithSidebar from './ContentWithSidebar';

const DEFAULT_ITEMS = 'flight-bookings';

export const items = [
  {
    slug: 'flight-bookings',
    title: 'Flight Bookings Report',
    component: ExportFlightBookingsForm,
  },
  {
    slug: 'charter-departure-manifest',
    title: 'Charter Departure Manifest',
    component: ExportCharterDepartureManifestForm,
  },
];

export default function FlightPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEMS} />;
}
